module.exports = __webpack_public_path__ + "img/goods10_4.7fb03e7f.jpg";